import { createCodedError } from '~/common/errors/CodedError';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { everest } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';
import { Uuid } from '~/types/Uuid';

type Request = {
  ticketId: Uuid;
  recipientId: Uuid;
  userId: PilotId;
};

type ServerRequest = {
  recipientId: Uuid;
  newSignerUserId: PilotId;
};

export const assignSigner = async (request: Request): Promise<void> => {
  try {
    await everest.patch(
      `tickets/${request.ticketId}/packages/reassign-initial-signer`,
      mapRequest(request),
    );

    return;
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }

    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    recipientId: request.recipientId,
    newSignerUserId: request.userId,
  };
};
